export default __webpack_public_path__ + "static/media/fondo1.08dfe64e.jpg";